<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Post actions overflow button">
  <ng-content></ng-content>
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="recommendUser()" [disabled]="wasRecommended" matTooltip="Recommend User" >
    Recommend User
  </button>
</mat-menu>
